import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { AlertTriangle } from 'lucide-react';
import { api } from '../lib/api';
import { useI18n } from '../lib/i18n';

type Row = { claim_id: string; claim_number: string | null; homeowner_name: string | null; insurance: string; days: number; days_left: number };

/**
 * Alerta: claims que se acercan (o pasaron) el deadline de recuperación de
 * depreciación de su aseguradora. Solo se muestra si hay alguno.
 */
export function DepreciationAlerts() {
  const { t } = useI18n();
  const [rows, setRows] = useState<Row[]>([]);
  useEffect(() => {
    api.get<{ claims: Row[] }>('/api/insurance/depreciation-approaching').then((r) => setRows(r.claims)).catch(() => {});
  }, []);
  if (rows.length === 0) return null;

  return (
    <div className="card" style={{ borderLeft: '4px solid #c0392b' }}>
      <h2 className="card-title" style={{ margin: 0, display: 'flex', alignItems: 'center', gap: 8, color: '#c0392b' }}>
        <AlertTriangle size={18} /> {t('depr.title')} <span className="badge red">{rows.length}</span>
      </h2>
      <div style={{ display: 'grid', gap: 6, marginTop: 10, maxHeight: 260, overflowY: 'auto' }}>
        {rows.map((r) => (
          <div key={r.claim_id} style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '6px 0', borderBottom: '1px solid var(--line)' }}>
            <Link to={`/claims/${r.claim_id}`} style={{ fontWeight: 600 }}>{r.claim_number || r.homeowner_name || `#${r.claim_id}`}</Link>
            <span className="muted" style={{ fontSize: 'var(--fs-2xs)' }}>{r.insurance} · {r.days}d</span>
            <span style={{ flex: 1 }} />
            <span className="badge" style={{ background: r.days_left < 0 ? '#c0392b' : '#fdecea', color: r.days_left < 0 ? '#fff' : '#c0392b', fontWeight: 700 }}>
              {r.days_left < 0 ? t('depr.overdue', { d: String(Math.abs(r.days_left)) }) : t('depr.left', { d: String(r.days_left) })}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
}
